import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home/View';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { initTheme } from './utils/theme';

function App() {
  const { t } = useTranslation();
  useEffect(() => {
    initTheme();
  }, []);
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={< Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;